import { useState } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Interest_Certificate, loanapplicationdocumentApi } from '../../Global/Index';
import BeatLoader from "react-spinners/BeatLoader";
import './Interest_Certificate.css'
import { TbSend } from 'react-icons/tb';
import { useTheme } from '@mui/material';

const override = {
  margin: "0 auto",
  marginLeft: '.3vw'
};

const InterestCertificate = () => {
 
  const [selectedYear, setSelectedYear] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [submitloader, setSubmitloader] = useState(false);
  const theme = useTheme();

  // Utility function to format date as YYYY-MM-DD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Get current quarter (1-4)
  const getCurrentQuarter = () => {
    const month = new Date().getMonth(); // 0-11 (Jan=0, Dec=11)
    if (month >= 0 && month <= 2) return 1; // Q1: Jan-Mar
    if (month >= 3 && month <= 5) return 2; // Q2: Apr-Jun  
    if (month >= 6 && month <= 8) return 3; // Q3: Jul-Sep
    return 4; // Q4: Oct-Dec
  };

  // Calculate fiscal year dates based on Indian Fiscal Year (April to March)
  const calculateFiscalYearDates = () => {
    const currentYear = new Date().getFullYear();
    const currentQuarter = getCurrentQuarter();
    
    let thisFiscalStart, thisFiscalEnd;
    
    if (currentQuarter === 2) {
      // Q2 (April-June): This fiscal year is April current year to March next year
      thisFiscalStart = new Date(currentYear, 3, 1); // April 1st current year (month is 0-indexed)
      thisFiscalEnd = new Date(currentYear + 1, 2, 31); // March 31st next year
    } else {
      // Q1, Q3, Q4: This fiscal year is April previous year to March current year
      thisFiscalStart = new Date(currentYear - 1, 3, 1); // April 1st previous year
      thisFiscalEnd = new Date(currentYear, 2, 31); // March 31st current year
    }

    // Calculate previous fiscal year (1 year before current fiscal year)
    const lastFiscalStart = new Date(thisFiscalStart.getFullYear() - 1, 3, 1);
    const lastFiscalEnd = new Date(thisFiscalEnd.getFullYear() - 1, 2, 31);

    return {
      currentFiscal: { 
        start: formatDate(thisFiscalStart), 
        end: formatDate(thisFiscalEnd) 
      },
      previousFiscal: { 
        start: formatDate(lastFiscalStart), 
        end: formatDate(lastFiscalEnd) 
      }
    };
  };

  // Handle year selection change
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
    
    const fiscalDates = calculateFiscalYearDates();
    
    if (e.target.value === 'thisYear') {
      setStartDate(fiscalDates.currentFiscal.start);
      setEndDate(fiscalDates.currentFiscal.end);
    } else if (e.target.value === 'previousYear') {
      setStartDate(fiscalDates.previousFiscal.start);
      setEndDate(fiscalDates.previousFiscal.end);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedYear === '') {
      toast.error('Please Select At Least One Date');
      return;
    }

    try {
      // Check DMS API for request status
      const dmsApiResponse = await loanapplicationdocumentApi();
      let requestStatus = 'Pending';

      if (dmsApiResponse?.response?.data) {
        const dmsResponseCategory = dmsApiResponse.response.data;

        if (dmsResponseCategory && dmsResponseCategory.subCategories) {
          dmsResponseCategory.subCategories.forEach(subCategory => {
            if (subCategory.name === 'Interest Certificate' &&
              subCategory.status === 'Uploaded' &&
              subCategory.documents &&
              subCategory.documents.length > 0
            ) {
              requestStatus = 'Closed'
            }
          });
        }
      }

      setSubmitloader(true);

      // Prepare customer details
      const customerdetail = {
        "fromDate": startDate,
        "toDate": endDate,
        "Status": requestStatus
      };

      // Submit interest certificate request
      const resp = await Interest_Certificate(customerdetail);

      // Handle API response
      if (resp.response.status === "200" && resp.response.message === 'Success') {
        toast.success('Request has been successfully submitted');
      } else if (resp.response.status === "419") {
        window.location.href = '/Session-Expired';
      } else if (resp.response.status === "500") {
        toast.error('Something went wrong. Please try again later!');
      } else if (resp.response.status === "503") {
        toast.warn(resp.response.message);
      } else if (resp.response.status === '401') {
        window.location.href = '/';
      }

      setSubmitloader(false);

    } catch (error) {
      console.error('Error:', error);
      toast.error('Something went wrong. Please try again later!');
      setSubmitloader(false);
    }
  };

  return (
    <div className="popupservicerequest" style={{ 
      backgroundColor: theme.palette.background.alt, 
      color: theme.palette.primary.main 
    }}>
      {/* Header */}
      <div className="popup-header"></div>

      {/* Body */}
      <div className="popup-body">
        {/* Title */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '1vw', 
          backgroundColor: theme.palette.background.alt, 
          color: theme.palette.primary.main, 
          padding: '1.4vh', 
          fontWeight: '700' 
        }}>
          Select Time Duration
        </div>

        {/* Form */}
        <div className='formdata'>
          {/* Year Selection */}
          <div className="selectyear">
            <label>
              <input
                type="radio"
                name="year"
                value="thisYear"
                onChange={handleYearChange}
                style={{ color: theme.palette.primary.main }}
              /> 
              This Year 
            </label>
            <label>
              <input
                type="radio"
                name="year"
                value="previousYear"
                onChange={handleYearChange}
                style={{ color: theme.palette.primary.main }}
              /> 
              Previous Year 
            </label>
          </div>
          
          {/* Date Display */}
          {selectedYear && (
            <div style={{ 
              margin: '.8vw', 
              fontWeight: '700', 
              backgroundColor: theme.palette.background.default, 
              padding: '.7vw', 
              textAlign: 'center' 
            }}>
              <p>
                Start Date: {startDate} - End Date: {endDate}
              </p>
              <p style={{ 
                fontSize: '0.9em', 
                fontWeight: '400', 
                marginTop: '0.5rem', 
                color: theme.palette.text.secondary 
              }}>
                ( April to March)
              </p>
            </div>
          )}

          {/* Submit Button */}
          <div style={{margin:'auto'}}>
            <button
              type="submit"
              onClick={handleSubmit}
              disabled={submitloader}
              id='servicerequestsubmitbutton'
              style={{
                background: theme.palette.maincolor.buttoncolor,
                color: theme.palette.maincolor.light,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
            >
              {submitloader ? (
                <>
                  <span>Processing</span>
                  <BeatLoader
                    color="rgb(155,57,19)"
                    loading={submitloader}
                    cssOverride={override}
                    size={6}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                </>
              ) : (
                <>
                  <TbSend size={20} />
                  <span>Submit</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Service2_Interest_Certificate = () => {
  return <InterestCertificate />;
};

export default Service2_Interest_Certificate;